export default __webpack_public_path__ + "static/media/2.a6c77882.png";